import * as React from "react";
import { connect } from "react-redux";

import Header from "components/header";
import { HeaderInMainGeoAnalysis } from "components/header-in-main";
import { DashboardGeoAnalysis } from "components/dashboard";
import { FilterWebsitesModal } from "components/modal";

import "./GeoAnalysis.scss";

import { closeModal, openModal } from "core/state/modal/actions";
import { getActiveModalName } from "core/state/modal/selectors";
import {
  loadWebsiteLinks,
  loadWebsites,
  loadWebsiteTypes
} from "core/state/websites/actions";
import { fetchCountries } from "core/state/meta/actions";
import { StoreShape } from "core/reducers";
import { getTitlesSelected } from "core/state/meta/selectors";
import { loadTitles } from "core/state/titles/actions";
import { withPackageDataLoader } from "components/dataHOC/mountLoaders";
import { countTrue } from "common/utils";
import { getProjectById } from "core/state/projects/selectors";

const MODAL_NAME = "FilterWebsitesModal";

const Page: React.SFC<{
  projectId: string;
  activeModal: string;
  titlesSelected: number;
  projectName: string;
  openFilterModal: () => void;
  closeFilterModal: () => void;
}> = ({
  projectId,
  activeModal,
  projectName,
  openFilterModal,
  closeFilterModal,
  titlesSelected
}) => (
  <div className="page">
    <Header className="page__header" />
    <main className="page__main">
      <HeaderInMainGeoAnalysis
        className="page__navigation"
        titlePage={`${projectName} Geo-Analysis`}
        captionSelected={`${titlesSelected} Titles selected`}
        onCaptionSelectedClick={openFilterModal}
        projectId={projectId}
      />
      <DashboardGeoAnalysis className="page__dashboard" projectId={projectId} />
    </main>
    <FilterWebsitesModal
      className="page__modal"
      visible={activeModal === "FilterWebsitesModal"}
      onClose={closeFilterModal}
      projectId={projectId}
    />
  </div>
);

const mapStateToProp = (
  state: StoreShape,
  { projectId }: { projectId: string }
) => ({
  activeModal: getActiveModalName(state),
  titlesSelected: countTrue(getTitlesSelected(state, projectId)),
  projectName: getProjectById(state, projectId).title
});

const mapDispatchToState = (dispatch: any) => ({
  openFilterModal: () => dispatch(openModal(MODAL_NAME)),
  closeFilterModal: () => dispatch(closeModal(MODAL_NAME))
});

export default withPackageDataLoader({
  page: [fetchCountries],
  hook: [loadTitles, loadWebsites, loadWebsiteTypes, loadWebsiteLinks]
})(connect(mapStateToProp, mapDispatchToState)(Page));
